export function firstLetterUppercase(s) {
	return s.charAt(0).toUpperCase() + s.slice(1)
}

export function checkIgnoringNonRelevantCharactersFromOptionLabel(option, query) {
	return checkIgnoringNonRelevantCharacters(option, query, 'label')
}

export function checkIgnoringNonRelevantCharacters(option, query, prop) {
	let baseProp = prop ? option[prop] : option
	return baseProp.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '').indexOf(query.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, ''))
}


// WEBPACK FOOTER //
// ./src/helpers/string.helpers.js